import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { TESTIMONIALS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/testimonials/new")({
  component: () => <DeptContentForm cfg={TESTIMONIALS} />,
});
